"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateEarliestDeliveryDate = exports.ISO_DATE_FORMAT = void 0;
const module_logistic_interfaces_1 = require("@invivodf/module-logistic-interfaces");
const dayjs_1 = __importDefault(require("dayjs"));
const customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
dayjs_1.default.extend(customParseFormat_1.default);
exports.ISO_DATE_FORMAT = 'YYYY-MM-DD';
const calculateEarliestDeliveryDate = (startingDate, delay) => {
    if (!delay) {
        return null;
    }
    const date = (0, dayjs_1.default)(startingDate, exports.ISO_DATE_FORMAT, true);
    if (!date.isValid())
        throw new Error('Wrong date format for starting date');
    const delayValue = delay.unit !== module_logistic_interfaces_1.LogisticDelayUnit.WorkingDay ? delay.value : calculateDelayValueForWorkingDays(date, delay.value);
    const delayUnit = delay.unit !== module_logistic_interfaces_1.LogisticDelayUnit.WorkingDay ? delay.unit : 'day';
    return (0, dayjs_1.default)(startingDate).add(delayValue, delayUnit).format(exports.ISO_DATE_FORMAT);
};
exports.calculateEarliestDeliveryDate = calculateEarliestDeliveryDate;
const SATURDAY_WEEK_DAY = 6;
const SUNDAY_WEEK_DAY = 7;
const NUMBER_OF_WORKINGDAYS_IN_WEEK = 5;
const NUMBER_OF_DAYS_IN_WEEK = 7;
const NUMBER_OF_DAYS_IN_WEEKEND = 2;
const calculateDelayValueForWorkingDays = (startingDate, numberOfWorkingDaysToAdd) => {
    const dayOfStartingDate = startingDate.day() || SUNDAY_WEEK_DAY;
    const numberOfDaysUntilWeekend = SATURDAY_WEEK_DAY - dayOfStartingDate;
    const restOfDays = numberOfWorkingDaysToAdd % NUMBER_OF_WORKINGDAYS_IN_WEEK;
    const numberOfCompleteWeeks = Math.floor(numberOfWorkingDaysToAdd / NUMBER_OF_WORKINGDAYS_IN_WEEK);
    const restOfDaysToCount = numberOfDaysUntilWeekend <= restOfDays
        ? restOfDays + NUMBER_OF_DAYS_IN_WEEKEND - (dayOfStartingDate === SUNDAY_WEEK_DAY ? 1 : 0)
        : restOfDays;
    return numberOfCompleteWeeks * NUMBER_OF_DAYS_IN_WEEK + restOfDaysToCount;
};
